import React from "react";

const HomeIcon = (props: any) => {
  return (
    <svg
    
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10.3977 21.8268H6.97629C5.29359 21.8268 3.9248 20.458 3.9248 18.7753V12.5918H4.52324V18.7753C4.52324 20.1278 5.62382 21.2283 6.97629 21.2283H9.79929V16.7602H11.4026V17.3586H10.3977V21.8268Z" />
      <path d="M16.9468 21.8268H13.5254V17.0594H14.1238V21.2283H16.9468C18.2993 21.2283 19.3999 20.1278 19.3999 18.7753V12.5918H19.9983V18.7753C19.9983 20.458 18.6295 21.8268 16.9468 21.8268Z" />
      <path d="M1.59968 12.995L1.17969 12.569L11.9233 1.98047L22.6467 12.569L22.2262 12.995L11.9227 2.821L1.59968 12.995Z" />
      <path d="M17.6775 3.50684H17.0791V7.78893H17.6775V3.50684Z" />
    </svg>
  );
};

export default HomeIcon;
